import React from 'react';
import { RightSidebar } from "../../../_partials/Layout";
import Sortable from "../../../../componets/Sortable";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { reorderTipSteps } from "../../../../actions/mine_craft/tipStepsActions";

const _SidebarIndex = () => {
  const dispatch = useAppDispatch();
  const reorderIds = useAppSelector(state => state.mineCraft.tipSteps.ids);
  const categories = useAppSelector(state => state.mineCraft.tipSteps.entities);

  function onClickSave(ids: any[]) {
    dispatch(reorderTipSteps({ ids }));
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>

      <hr className="v-divider" />

      <h6 className="v-content-label o-sm">Reorder Help Steps</h6>

      {
        reorderIds &&
          <Sortable
            ids={reorderIds}
            onClickSave={onClickSave}
            items={categories}
            titleKey='title'
            imageKey='image_url'
          />
      }
    </RightSidebar>
  )
}

export default _SidebarIndex;
